import Swiper, { Autoplay } from "swiper";

const setBnrSlider = () => {
  const target = document.getElementById('js-banner-slider')
  if (!target) return false;

  const slides = target.querySelectorAll('.swiper-slide');
  if (slides.length > 1) {
    const swiper = new Swiper(target, {
      modules: [Autoplay],
      autoplay: {
        disableOnInteraction: false,
        delay: 3500,
        pauseOnMouseEnter: false,
      },
      speed: 1200,
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      speed: 400,
    });
  }

  target.classList.add('is-init')
};

export default setBnrSlider;